












































































import { Component, Vue } from 'vue-property-decorator';
import {i18n} from '../plugin/i18n';
import ButtonNextPage from '../components/ButtonNextPage.vue';
import ArticleSection from '../components/ArticleSection.vue';
import ArticleTop from '../components/ArticleTop.vue';
import ImageList from '../components/ImageList.vue';
import ArticleSectionImage from '../components/ArticleSectionImage.vue';
import Author from '../components/Author.vue';
import VideoPlayer from '../components/VideoPlayer.vue';
import Quote from "../components/Quote.vue";
import {Meta} from '../decorators/decorators';

@Component({
    components: {VideoPlayer, ArticleSectionImage, ImageList, ArticleTop, ArticleSection, ButtonNextPage, Author, Quote},
})
export default class Arty extends Vue {
    title: String = i18n.t('Arty.title') as string;
    subTitle: String = i18n.t('Arty.subTitle') as string;
    intro: String = i18n.t('Arty.intro') as string;
    authorName: String = i18n.t('Arty.authorName') as string;
    authorTitle: String = i18n.t('Arty.authorTitle') as string;
    authorQuote: String = i18n.t('Arty.authorQuote') as string;
    imageCaption: String = i18n.t('Arty.imageCaption') as string;
    video: String = i18n.t('Arty.video') as string;

    @Meta
    myMetaConfig() {
        return {
            title:  i18n.t('Arty.title')
        }
    }


    mounted() {
    }
}
